module.exports = __webpack_public_path__ + "img/osa_cloud.71adbc5e.svg";